import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Verificar() {
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(({ data }) => { signIn(data); navigate("/mi-panel", { replace: true }); })
      .catch((e) => setError(errMsg(e, "El enlace no es válido")));
  }, [params, signIn, navigate]);

  return (
    <AuthShell testid="verificar-page" overline="Confirmación" title={error ? "Algo no salió bien." : "Confirmando tu correo…"}>
      {error && (
        <>
          <p data-testid="verificar-error" className="text-zinc-400 mb-6">{error}. Si ya confirmaste antes, simplemente entra.</p>
          <Link to="/ingresar" data-testid="verificar-to-login" className="btn-lilac">Ir a entrar</Link>
        </>
      )}
    </AuthShell>
  );
}
